module.exports = __webpack_public_path__ + "img/pr-12.ae93e76e.png";